angular.module('leanlaw').controller('ExpenseStandardCtrl', ['$scope', 'company', 'alerts', '$state', 'userService', 'codeService', '$stateParams', function ($scope, company, alerts, $state, userService, codeService, $stateParams) {
  $scope.company = {};
  $scope.codes = {};
  $scope.expense = {};
  activate();
  $scope.save = function () {
    if (!$scope.expense.amount) {
      return alerts.warning('Please enter an amount');
    }
    if (!$scope.expense.description) {
      return alerts.warning('Please enter a description');
    }
    if (!$scope.label) {
      return alerts.warning('Please enter a label');
    }
    if (!$scope.company.settings.expenses) {
      $scope.company.settings.expenses = {
        standard: []
      };
    }
    if (!$scope.company.settings.expenses.standard) {
      $scope.company.settings.expenses.standard = [];
    }
    $scope.company.settings.expenses.standard.push({
      label: $scope.label,
      amount: $scope.expense.amount,
      description: $scope.expense.description,
      code: $scope.expense.code
    });
    company.update({
      settings: {
        expenses: $scope.company.settings.expenses
      }
    }).then(() => {
      $state.go('^');
    }).catch(function (err) {
      alerts.error(`Failed to save standard expense: ${err?.body?.message}`);
    });
  };

  ///////////////////////////////////

  async function activate() {
    $scope.loading = true;
    $scope.expense = $stateParams?.expense;
    const me = await userService.me();
    const expense = await codeService.expenseCodes();
    $scope.company = me.company;
    $scope.codes.expense = expense;
    if ($scope.expense?.codeId) {
      $scope.expense.code = expense.find(code => code.id === $scope.expense.codeId);
    }
    $scope.label = ($scope.expense?.description || '').substring(0, 30);
    $scope.loading = false;
  }
}]);